// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"dr-z","slideIn":"er-z"};